var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniEtc03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.939453,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#448D97"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_15973",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.939453,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_15973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.11 204.961C154.175 212.194 168.875 213.305 178.21 213.305C185.99 212.865 188.833 209.139 188.572 207.524C188.096 204.592 189.128 202.764 185.08 198.368C181.033 193.972 157.451 178.954 146.012 174.008C134.573 169.063 122.068 166.935 117.327 171.627C114.037 174.884 114.679 180.502 117.327 185.534C119.38 189.442 128.11 198.789 140.11 204.961Z",
    fill: "#10201C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.608 143.792C244.235 154.697 258.681 153.74 264.88 153.74C275.406 153.417 278.883 148.72 278.64 147.307C278.2 144.744 279.156 143.145 275.406 139.301C271.655 135.457 249.806 122.325 239.207 118.001L239.159 117.981C228.565 113.659 214.348 107.858 209.962 111.955C206.914 114.803 208.284 123.588 210.737 127.988C213.19 132.389 216.114 137.3 226.608 143.792Z",
    fill: "#10201C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9555 135.612C89.7527 132.629 87.1816 126.469 87.1816 120.816C87.4793 113.032 89.5293 118.056 91.0836 118.056C92.6379 118.056 96.2051 124.532 97.2413 130.002C98.2775 135.471 122.907 161.998 102.836 147.141C97.614 143.276 94.126 138.552 91.9857 135.653L91.9555 135.612Z",
    fill: "#10201C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9746 121.491C88.7202 137.428 110.42 153.118 121.177 158.97L120.746 140.916C117.185 138.457 109 133.616 98.9114 124.629C90.8406 117.44 88.2574 104.622 87.9746 99.1113V121.491Z",
    fill: "#B45B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.209 159.001L120.764 141.358L124.134 138.912L124.318 156.113L121.209 159.001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.745 156.121L121.447 143.904L123.612 142.133L123.777 154.281L121.745 156.121Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.745 156.116L121.447 143.898L131.636 149.595L130.201 160.848L121.745 156.116Z",
    fill: "#D07D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.99 85.7536C247.005 84.39 246.735 81.2445 245.535 79.5723",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.806 85.5286C248.094 83.9985 248.333 80.3291 246.988 77.8926",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.133 208.153C194.682 208.476 193.314 208.824 191.455 207.637",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.377 207.09C195.943 207.324 194.839 207.564 193.885 206.654",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.861 188.936C205.211 189.098 203.281 189.325 200.768 188.936",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.025 187.635C205.339 187.815 203.545 188.068 201.854 187.635",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.957 198.85C195.364 199.555 196.595 201.039 198.26 201.326",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.354 198.023C195.593 198.597 196.452 199.796 197.974 199.997",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.431 132.444C156.9 131.647 150.661 136.099 148.482 138.424C154.611 158.177 162.797 199.302 163.683 205.416C164.79 213.059 188.286 214.672 195.043 208.47C200.552 203.991 205.706 195.334 206.52 183.947C207.185 174.648 201.647 158.029 192.786 148.061C183.925 138.093 173.846 133.44 164.431 132.444Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.862 136.773C147.598 137.583 147.371 139.657 146.311 141.018C156.58 163.959 175.448 209.606 178.812 210.663C183.015 211.985 192.598 206.283 195.853 195.878C198.779 187.831 197.358 176.782 194.871 169.999C190.065 156.89 180.3 145.799 170.697 140.244C160.91 134.582 152.31 136.413 150.862 136.773Z",
    fill: "#D68585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.533 137.861L134.262 146.622C134.13 159.124 136.085 186.442 144.967 195.699C156.07 207.27 165.687 209.851 174.053 211.18C182.418 212.509 187.71 206.662 189.289 204.767L189.334 204.713C191.578 202.024 197.291 195.173 195.463 179.145C191.134 159.177 178.457 147.569 169.641 141.908C161.832 136.894 152.427 136.842 148.533 137.861Z",
    fill: "#B45B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.761 149.659L121.447 143.904L123.612 142.133L133.793 147.819L131.761 149.659Z",
    fill: "#FFC8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.926 101.633L219.922 78.3058L222.844 75.3125L222.848 98.8748L219.926 101.633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.703 97.1069C105.886 104.272 98.9954 116.557 100.589 123.139C95.3909 117.929 93.4833 115.325 92.9806 112.894C91.3876 107.235 88.3378 97.7695 95.9837 90.0231C105.541 80.34 117.062 74.4979 134.336 70.4194C148.862 66.9895 168.579 65.6823 187.309 68.2229C202.536 70.2882 216.11 75.0011 219.925 77.8093V101.405C214.542 99.6572 209.34 97.0619 184.189 91.6552C159.038 86.2485 136.021 88.6441 119.703 97.1069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.82 144.114C127.627 144.92 127.109 160.994 128.048 169.102C129.657 178.016 134.07 184.585 139.14 190.691C155.261 209.269 170.099 206.249 173.453 204.497C177.004 202.642 185.61 194.766 183.238 181.509C181.415 171.323 172.679 160.489 168.896 156.646C165.047 152.736 154.988 143.367 141.82 144.114Z",
    fill: "#B45B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.269 152.382C127.579 152.612 128.035 166.257 130.099 173.05C135.14 187.816 148.191 198.024 153.359 200.268C159.231 202.817 171.722 202.212 174.674 193.715C177.627 185.217 173.919 177.06 173.22 175.523C172.862 174.736 160.632 152.094 142.269 152.382Z",
    fill: "#D68585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.749 86.9344L220.436 81.179L222.6 79.4082L232.782 85.0939L230.749 86.9344Z",
    fill: "#FFC8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.733 97.4973L220.436 81.1758L230.624 86.8722L229.189 102.229L220.733 97.4973Z",
    fill: "#D07D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.16 138.906L120.761 141.352C101.768 131.613 93.0325 120.072 89.9817 111.881C84.2981 96.6294 92.3531 89.0196 97.0894 84.613C102.545 79.1033 118.267 68.3994 140.256 65.5469C151.872 64.0399 161.127 63.1473 174.708 63.9399C201.538 65.9438 217.962 72.3426 222.833 75.3114L219.889 78.328C216.772 76.5467 205.508 72.8772 200.033 71.6403C191.923 69.9557 171.772 66.886 156.05 68.0838C136.398 69.5811 127.859 71.922 124.116 73.4192C120.373 74.9165 110.214 78.0361 101.917 85.1482C94.4795 91.5228 92.5088 95.2704 91.9306 99.0609C90.1135 117.927 113.328 133.648 124.16 138.906Z",
    fill: "#FFC8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.419 114.834C211.243 112.989 212.883 107.26 213.724 104.627L216.25 109.347L227.885 127.239C235.789 131.996 251.683 141.575 252.035 141.838C252.386 142.102 272.525 140.924 282.55 140.302C287.197 136.935 296.096 131.3 294.515 135.691C292.539 141.18 284.197 154.132 259.938 153.145C235.679 152.157 222.594 138.674 217.431 131.707C212.593 125.178 211.64 117.14 211.419 114.834Z",
    fill: "#B45B5B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.293,
    cy: 112.723,
    rx: 45.4707,
    ry: 34.0711,
    transform: "rotate(22.8984 256.293 112.723)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.242 134.013C227.431 132.766 228.172 129.978 229.622 128.801",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.142,
    cy: 107.049,
    rx: 21.3383,
    ry: 12.9678,
    transform: "rotate(22.8984 257.142 107.049)",
    fill: "#AB5050"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.264,
    cy: 109.991,
    rx: 18.2388,
    ry: 11.0842,
    transform: "rotate(22.8984 259.264 109.991)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.725 125.377C267.949 132.23 284.478 129.792 288.642 119.933C292.807 110.073 283.031 96.5245 266.807 89.6717C250.582 82.8189 234.054 85.2565 229.889 95.1163C225.725 104.976 235.501 118.524 251.725 125.377ZM254.953 117.736C264.233 121.656 273.686 120.262 276.068 114.622C278.45 108.983 272.858 101.234 263.579 97.3149C254.3 93.3955 244.847 94.7897 242.465 100.429C240.083 106.068 245.674 113.817 254.953 117.736Z",
    fill: "#D68585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.707 109.067C213.186 107.207 214.876 103.164 217.805 101.875",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.59 113.391C213.816 111.729 214.734 108.177 216.593 107.271",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.83 132.882C226.227 130.842 227.848 126.14 231.156 123.646",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.496 131.611C224.601 129.672 225.59 125.432 228.702 123.986",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.687 125.48C251.721 126.806 251.446 129.91 250.076 131.723",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.957 126.031C253.108 126.568 253.319 127.945 252.957 129.153",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.982 141.006C184.412 141.086 183.184 141.502 182.832 142.519",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.053 140.252C183.171 140.555 181.225 141.479 180.5 142.748",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.102 159.934C199.431 160.139 197.703 160.782 196.154 161.712",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.858 160.93C200.342 161.103 199.091 161.616 198.213 162.287",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.097 136.269C160.027 135.608 160.257 134.108 161.744 133.398",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.939 136.522C160.982 136.029 161.279 134.942 162.123 134.537",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.654 141.885C173.851 141.294 174.491 140.068 175.47 139.9",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.801 156.162C188.279 155.529 189.549 154.213 190.799 154.01",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.139 156.67C188.589 156.219 189.676 155.267 190.42 155.064",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.502 172.097L141.033 164.285L144.098 166.455C145.873 167.712 146.117 169.529 145.028 171.066C143.924 172.626 142.128 172.966 140.326 171.69L138.923 170.697L137.12 173.243L135.502 172.097ZM139.848 169.391L140.992 170.201C141.952 170.881 142.803 170.674 143.356 169.882C143.911 169.109 143.812 168.254 142.856 167.568L141.712 166.758L139.848 169.391Z",
    fill: "#EDAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 177.451C142.35 177.092 142.226 176.397 142.592 175.903C142.933 175.399 143.629 175.284 144.133 175.649C144.617 175.983 144.746 176.682 144.394 177.178C144.039 177.68 143.337 177.791 142.857 177.451Z",
    fill: "#EDAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.138 178.92L150.669 171.108L153.733 173.277C155.508 174.534 155.753 176.351 154.664 177.889C153.56 179.448 151.764 179.788 149.962 178.512L148.559 177.519L146.756 180.066L145.138 178.92ZM149.484 176.214L150.627 177.023C151.588 177.703 152.439 177.496 152.991 176.705C153.547 175.932 153.448 175.076 152.492 174.391L151.348 173.581L149.484 176.214Z",
    fill: "#EDAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.118 177.09L153.586 184.902L151.989 183.771L157.521 175.959L159.118 177.09Z",
    fill: "#EDAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.398 187.779C155.605 186.501 155.326 184.562 156.645 182.71C157.919 180.899 159.903 180.465 161.619 181.679C163.157 182.768 163.683 184.599 162.269 186.595L161.949 187.048L157.945 184.214C157.319 185.098 157.456 186.014 158.278 186.604C158.827 186.984 159.383 187.022 159.788 186.782L161.309 187.859C160.315 188.783 158.847 188.797 157.398 187.779ZM158.656 183.21L161.148 184.975C161.647 184.259 161.519 183.399 160.803 182.9C160.073 182.375 159.166 182.559 158.656 183.21Z",
    fill: "#EDAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.607 242.053V222.256H190.373C194.871 222.256 197.455 225.031 197.455 228.928C197.455 232.879 194.83 235.6 190.264 235.6H186.709V242.053H182.607ZM186.709 232.291H189.607C192.041 232.291 193.23 230.924 193.217 228.928C193.23 226.959 192.041 225.633 189.607 225.619H186.709V232.291ZM201.42 242.299C200.135 242.299 199.096 241.273 199.123 240.002C199.096 238.744 200.135 237.719 201.42 237.732C202.637 237.719 203.689 238.744 203.689 240.002C203.689 241.273 202.637 242.299 201.42 242.299ZM207.025 242.053V222.256H214.791C219.289 222.256 221.873 225.031 221.873 228.928C221.873 232.879 219.248 235.6 214.682 235.6H211.127V242.053H207.025ZM211.127 232.291H214.025C216.459 232.291 217.648 230.924 217.635 228.928C217.648 226.959 216.459 225.633 214.025 225.619H211.127V232.291ZM228.436 222.256V242.053H224.389V222.256H228.436ZM238.307 242.354C233.754 242.34 230.965 239.4 230.979 234.697C230.965 230.117 233.795 227.014 238.143 227.014C242.039 227.014 245.115 229.475 245.115 234.533V235.682H234.971C234.971 237.924 236.297 239.305 238.389 239.318C239.77 239.305 240.754 238.703 241.15 237.814H245.006C244.432 240.562 241.971 242.34 238.307 242.354ZM234.971 233.139H241.287C241.273 231.334 240.029 230.035 238.225 230.049C236.365 230.035 235.053 231.43 234.971 233.139Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniEtc03);
export default __webpack_public_path__ + "static/media/mini_etc_03.79acae7b0c8b380a8ba037ba4eb29c09.svg";
export { ForwardRef as ReactComponent };